import React, {useEffect } from 'react'; 
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const MultiPurposeHall = () => {
    useEffect(() => {
        document.title = 'Multi Purpose Hall -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li> 
                 <li>Multi Purpose Hall - The Aravali Hall</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Multi Purpose Hall - The Aravali Hall </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                   <p> The school has a huge Multi-Purpose Hall – The Aravali Hall with a seating capacity of 300-400 people. The hall is used for Inter-School programmes and school functions. It also doubles up as an indoor games hall.</p>
                </div>
                <div className="col-lg-4">
                 <LazyLoad>
                 <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/MultiPurposeHall.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/MultiPurposeHall.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
               </LazyLoad>  
                </div>
                <div className="col-lg-4">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/MultiPurposeHall1.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/MultiPurposeHall1.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
              </LazyLoad>  
               </div>
               <div className="col-lg-4">
               <LazyLoad>
               <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/MultiPurposeHall2.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/MultiPurposeHall2.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
             </LazyLoad>  
              </div> 
            </div>
            </div>
        </div>
     </>
  )
}

export default MultiPurposeHall